import { OktaAuth } from '@okta/okta-auth-js';

import { environment } from '@env/environment';

export const oktaAuth = new OktaAuth({
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: `${window.location.origin}${environment.okta.redirectPath}`,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
});
